import React from 'react';

interface VersionBadgeProps {
  version: string;
  buildVersion?: string;
  size?: 'sm' | 'md' | 'lg';
  showBuildVersion?: boolean;
}

const VersionBadge: React.FC<VersionBadgeProps> = ({
  version,
  buildVersion,
  size = 'md',
  showBuildVersion = false,
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'px-2 py-1 text-xs';
      case 'lg':
        return 'px-4 py-2 text-base';
      default:
        return 'px-3 py-1 text-sm';
    }
  };

  const displayText =
    showBuildVersion && buildVersion ? `${version} (${buildVersion})` : version;

  return (
    <span
      className={`
        inline-flex items-center rounded-full border font-medium
        bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-200 border-green-200 dark:border-green-800
        ${getSizeClasses()}
      `}
    >
      {displayText}
    </span>
  );
};

export default VersionBadge;
